import store from '../store';

export default function (to, from, next) {

    if (store.getters.isLogin) {

        let check = () => {

            if (store.state.user.profile.is_paid) {
                next();
            } else {
                next({name: 'profile'});
            }
        }

        if (store.state.user.profileIsLoaded) {
            check();
        } else {
            store.dispatch('loadUserProfile')
                .then(() => {
                    check();
                });
        }

    } else {
        next({name: 'login'});
    }
}
